import { OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { UiService } from '../ui/ui.service';
var EventsPageComponent = /** @class */ (function () {
    function EventsPageComponent(ui) {
        this.ui = ui;
    }
    EventsPageComponent.prototype.ngOnInit = function () {
    };
    EventsPageComponent.prototype.ngAfterViewInit = function () {
        this.ui.whitened$.next(true);
    };
    EventsPageComponent.prototype.ngOnDestroy = function () {
        this.ui.whitened$.next(false);
    };
    return EventsPageComponent;
}());
export { EventsPageComponent };
//# sourceMappingURL=events-page.component.js.map